import { Dialog as MUIDialog, DialogProps } from '@mui/material';

import styles from './Dialog.module.scss';

const Dialog: React.FC<DialogProps> = (props) => {
  return <MUIDialog classes={{ root: styles.container }} {...props} />;
};

export default Dialog;
